import request from "@/utils/request";

export function getDreportType (data){
  return request({
    url:'/osp/Dreport/getDreportType',
    method:'post',
    data: data
  })
}

export function getDreporSales (data){
  return request({
    url:'/osp/Dreport/getDreporSales',
    method:'post',
    data: data
  })
}
